import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import logo from '../logo.png';



const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const location = useLocation();

  // Detect screen resize for responsive design
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const navigation = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Portfolio', path: '/portfolio' },
    { name: 'Team', path: '/team' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  const glassStyle=isMobile
  ?{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 50,
      background: 'rgba(255, 255, 255, 0.15)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      borderBottom: '1px solid rgba(255, 255, 255, 0.3)',
      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
      width: '100%',
      margin: '0 auto',
      padding: '8px 12px',
    }
  : {
      position: 'fixed',
      top: 10,
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 50,
      borderRadius: '10px',
      background: 'rgba(255, 255, 255, 0.15)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
      width: '90%',
      maxWidth: '1200px',
      padding: '5px 20px',
    };

  // 💎 Glass effect responsive styles
  // const glassStyle = isMobile
  //   ? {
  //       position: 'sticky',
  //       top: 0,
  //       zIndex: 50,
  //       background: 'rgba(255, 255, 255, 0.15)',
  //       backdropFilter: 'blur(10px)',
  //       WebkitBackdropFilter: 'blur(10px)',
  //       borderBottom: '1px solid rgba(255, 255, 255, 0.3)',
  //       boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
  //       width: '100%',
  //       margin: 0,
  //       borderRadius: 0,
  //       padding: '8px 12px',
  //     }
  //   : {
  //       position: 'sticky',
  //       top: 10,
  //       zIndex: 50,
  //       borderRadius: '10px',
  //       background: 'rgba(255, 255, 255, 0.15)',
  //       backdropFilter: 'blur(10px)',
  //       WebkitBackdropFilter: 'blur(10px)',
  //       // borderBottom: '1px solid rgba(255, 255, 255, 0.3)',
  //       boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
  //       width: '90%',
  //       maxWidth: '1200px',
  //       margin: '0 auto',
  //       padding: '5px 20px',
  //     };

  return (
    <header style={glassStyle}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div
            style={{
              width: '32px',
              height: '32px',
              
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden', // ensures image fits nicely inside rounded div
            }}
          >
            <img
              src={logo} // if your logo.png is in the public folder
              alt="Logo"
              style={{
                width: '32px',
                height: '32px',
                objectFit: 'contain', // keeps aspect ratio
              } }
             />
          </div>
{/* <span className="relative -top-0.4 font-extrabold text-2xl">7</span> */}
            <span style={{ fontSize: '20px', fontWeight: 'normal', color: '#000',fontFamily:'GCPalioka' }}>
           NS7VISUALS         </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                style={{
                  fontWeight: 500,
                  color: isActive(item.path) ? '#000' : '#323232ff',
                  borderBottom: isActive(item.path) ? '2px solid #000' : 'none',
                  paddingBottom: isActive(item.path) ? '4px' : '0',
                  transition: 'all 0.3s ease',
                }}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Link
              to="/contact"
              style={{
                background: '#000',
                color: '#fff',
                padding: '8px 16px',
                borderRadius: '8px',
                fontWeight: 600,
                transition: 'all 0.3s ease',
              }}
            >
              Get Quote
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            style={{ color: '#000' }}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div
            className="md:hidden"
            style={{
              background: 'rgba(255,255,255,0.3)',
              backdropFilter: 'blur(10px)',
              borderRadius:'4px',
              borderTop: '1px solid rgba(255,255,255,0.2)',
            }}
          >
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  style={{
                    display: 'block',
                    padding: '10px 12px',
                    borderRadius: '8px',
                    fontWeight: 500,
                    color: isActive(item.path) ? '#000' : '#555',
                    background: isActive(item.path)
                      ? 'rgba(255,255,255,0.5)'
                      : 'transparent',
                  }}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <div className="px-3 py-2">
                <Link
                  to="/contact"
                  style={{
                    display: 'block',
                    textAlign: 'center',
                    background: '#000',
                    color: '#fff',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    fontWeight: 600,
                  }}
                >
                  Get Quote
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
